import BaseOption from "%/dynamic-component-editor/classes/base-option";

export function createOptionClass(config) {
  const {
    name,
    label,
    userInterfaceComponent,
    defaultValue,
    defaultHoverValue,
    defaultStateValues,
    validations = [],
    action = {},
    descriptionMessage = "",
    canSetAsVariable = true,
    useDivider = true,
    bundleOptions = [], // only applicable when using a inspectorToolGroup
  } = config;

  // Create the class dynamically
  const OptionClass = {
    [name]: class extends BaseOption {
      static label = label;
      static userInterfaceComponent = userInterfaceComponent;
      static defaultValue = defaultValue;
      static validations = validations;
      static action = action;
      static descriptionMessage = descriptionMessage;
      static canSetAsVariable = canSetAsVariable;
      static bundleOptions = bundleOptions;
      static useDivider = useDivider;
    },
  }[name];

  if (defaultHoverValue !== undefined) {
    OptionClass.defaultHoverValue = defaultHoverValue;
  }

  if (defaultStateValues !== undefined) {
    OptionClass.defaultStateValues = defaultStateValues;
  }

  return OptionClass;
}
